module.exports = __webpack_public_path__ + "img/745e6a3.jpg";